export const COMPANY = {
  name: "Taylor Made Plumbing & Services",
  shortName: "Taylor Made Plumbing",
  owner: "Jason Taylor",
  phone: "501-487-7290",
  phoneLink: "tel:+15014877290",
  email: "taylormade.ps001@gmail.com",
  emailLink: "mailto:taylormade.ps001@gmail.com",
  location: "Conway, Arkansas",
  tagline1: "Plumbing Done Right",
  tagline2: "Taylor Made For You",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    title: "Drain Cleaning",
    icon: "Waves",
    desc: "Fast, thorough drain clearing for sinks, tubs, showers, and main lines. We restore flow without the mess.",
  },
  {
    title: "Pipe Repair",
    icon: "Wrench",
    desc: "Bursts and corroded lines fixed right the first time with quality materials and clean workmanship.",
  },
  {
    title: "Toilet Installation & Repair",
    icon: "ShowerHead",
    desc: "From running toilets and clogs to brand-new installs — we handle it with care and zero hassle.",
  },
  {
    title: "Water Heater Services",
    icon: "Flame",
    desc: "Installation, repair, and replacement of water heaters — tank and tankless. Hot water back on, fast.",
  },
  {
    title: "Power Washing",
    icon: "Sparkles",
    desc: "Driveways, siding, decks, and walkways brought back to like-new with safe, professional power washing.",
  },
  {
    title: "Junk Removal",
    icon: "Trash2",
    desc: "Cleanouts, hauls, and yard junk gone — quick, clean, and respectful of your property.",
  },
  {
    title: "Demolition",
    icon: "Hammer",
    desc: "Safe small-scale interior and exterior demolition. We tear out, clean up, and prep for what's next.",
  },
  {
    title: "General Plumbing",
    icon: "Pipette",
    desc: "Faucets, fixtures, water heaters, and everyday plumbing maintenance — done by a name you can trust.",
  },
];

export const WHY_US = [
  { title: "Honest Pricing", icon: "BadgeDollarSign", desc: "Straight quotes. No surprises. No upsell games." },
  { title: "Fast Response Times", icon: "Clock", desc: "We answer the phone and show up when we say we will." },
  { title: "Quality Workmanship", icon: "ShieldCheck", desc: "Done right the first time — built to last." },
  { title: "Customer Satisfaction", icon: "Smile", desc: "We're not done until you're genuinely happy." },
  { title: "Locally Owned & Operated", icon: "MapPin", desc: "Conway, AR neighbors serving neighbors." },
  { title: "Residential & Small Commercial", icon: "Building2", desc: "Homes, rentals, and small businesses welcome." },
];

export const TESTIMONIALS = [
  {
    name: "Megan R.",
    location: "Conway, AR",
    rating: 5,
    text: "Jason came out the same day to fix a busted water line. Fair price, clean work, and he explained everything. We won't call anyone else.",
  },
  {
    name: "Brian H.",
    location: "Mayflower, AR",
    rating: 5,
    text: "Honest pricing and a real craftsman. Replaced two toilets and cleared a stubborn drain in one visit. Highly recommend.",
  },
  {
    name: "Allison P.",
    location: "Greenbrier, AR",
    rating: 5,
    text: "Power washed our driveway and porch — looks brand new. Showed up on time, super respectful, great communication.",
  },
  {
    name: "Derrick S.",
    location: "Vilonia, AR",
    rating: 5,
    text: "Leak detection saved us thousands. Found it behind a wall fast and patched it up the same day. Taylor Made for sure.",
  },
];

export const SERVICE_AREAS = [
  "Conway",
  "Mayflower",
  "Greenbrier",
  "Vilonia",
  "Maumelle",
  "Cabot",
  "Morrilton",
  "Bryant",
  "Little Rock",
  "Sherwood",
  "Jacksonville",
  "Benton",
];

export const FAQS = [
  {
    q: "Do you charge for estimates?",
    a: "Standard estimates are free. We give you an honest, written quote up front — no hidden fees and no pressure.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Conway, AR and serve the surrounding communities including Mayflower, Greenbrier, Vilonia, Maumelle, Cabot, and Little Rock.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes — we operate as a licensed, insured plumbing and home services business so you're protected on every job.",
  },
  {
    q: "How do I know if my water heater needs replacing?",
    a: "Common signs include lukewarm or no hot water, rust-colored water, popping or rumbling sounds, or a unit over 10 years old. Call us and we'll diagnose it on-site.",
  },
  {
    q: "Do you handle small commercial jobs?",
    a: "Absolutely. We work with homeowners, landlords, and small businesses across Central Arkansas.",
  },
];

export const GALLERY = [
  {
    before: "https://images.unsplash.com/photo-1581094289810-adf5d25690e3?auto=format&fit=crop&w=900&q=70",
    after: "https://images.pexels.com/photos/4048080/pexels-photo-4048080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Bathroom Fixture Upgrade",
  },
  {
    before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=900&q=70",
    after: "https://static.prod-images.emergentagent.com/jobs/36849de3-99f1-4387-8bcd-c63a5f80b908/images/eace74ad815fb9c34e26e11fa917be48b0381ed023c4b0fd2a9b49d906409988.png",
    label: "Pipe Replacement",
  },
  {
    before: "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=900&q=70",
    after: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=900&q=70",
    label: "Drain Restoration",
  },
];

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_taylor-made-plumbing/artifacts/q6xgjk23_image.png",
  owner: "https://customer-assets.emergentagent.com/job_taylor-made-plumbing/artifacts/1pna40lv_image.png",
  beforeAfter: "https://static.prod-images.emergentagent.com/jobs/36849de3-99f1-4387-8bcd-c63a5f80b908/images/28bc22b33903b1fe75acb5b93e45b40f4ec93da76f0371bdc195682e495c3342.png",
  plumberWorking: "https://images.unsplash.com/photo-1673870861507-d72aa6855d89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwbHVtYmVyJTIwd29ya2luZyUyMHRvb2xzfGVufDB8fHx8MTc3OTgwNzkzMHww&ixlib=rb-4.1.0&q=85",
};
